import styled from 'styled-components';
import { Spacer } from '@ontruck/orc';

export const StyledZeroReults = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
`;

export const StyledAdd = styled(Spacer)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 32px;
`;
